import {firestore, getBasePath} from '../firebase';
import {mapSnapshot} from "../api";

export const FETCH_TEAM = "FETCH_TEAM";
export function fetchTeam(){
    return {
        type: FETCH_TEAM,
        payload: firestore
            .doc(getBasePath())
            .get()
            .then(sh => mapSnapshot(sh))
            .then(res => Object.values(res)[0])
    };
}

export function fetchTeamIfNeeded(){
    return (dispatch, state) => {
        const {teams} = state();
        if(!teams.fetching && !teams.fetched){
            dispatch(fetchTeam())
        }
    };
}

export const ADD_BILLING = "ADD_BILLING";
export function addBilling(data){
    return {
        type: ADD_BILLING,
        payload:firestore
            .doc(getBasePath())
            .collection("billing")
            .doc("stripeSource")
            .set(data)
    }
}

export const FETCH_BILLING = "FETCH_BILLING";
export function fetchBillingIfNeeded(){
    return (dispatch, state) => {
        if(state().teams.fetchedBilling || state().teams.fetchingBilling) return;
        dispatch({
            type: FETCH_BILLING,
            payload: firestore
                .doc(getBasePath() + "/billing/stripe")
                .get()
                .then(sh => mapSnapshot(sh))
                .then(res => Object.values(res)[0])
        })
    }
}

export const RETRY_BILLING = "RETRY_BILLING";
export function retryBilling(){
    return {
        type: RETRY_BILLING
    }
}

export const RESET_BILLING_ADDED = "RESET_BILLING_ADDED";
export function resetBillingAdded(){
    return {
        type: RESET_BILLING_ADDED
    }
}


// WEBPACK FOOTER //
// ./src/actions/TeamActions.js